import { render, staticRenderFns } from "./CreditNoteCreate.vue?vue&type=template&id=735e8495&"
import script from "./CreditNoteCreate.vue?vue&type=script&lang=js&"
export * from "./CreditNoteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports